import React, { FC } from 'react';
import ReactDOM from 'react-dom';
import TooltipPortal from './tooltipPortal';
import { TPortalComopnent } from './types/infoToolTip.types';

const PortalComponent: FC<TPortalComopnent> = (props) => {
  const { tooltipDiv, children, getTooltipIconDimensions, width, tooltipVisibility } = props;

  const isReactDOMPresent = typeof ReactDOM !== 'undefined' ? ReactDOM : null;
  if (!isReactDOMPresent || !tooltipDiv) {
    return null;
  }
  return (
    <>
      {ReactDOM &&
        ReactDOM?.createPortal(
          <TooltipPortal getTooltipIconDimensions={getTooltipIconDimensions} width={width} tooltipVisibility={tooltipVisibility}>
            {children}
          </TooltipPortal>,
          tooltipDiv
        )}
    </>
  );
};

export default PortalComponent;
